import { createUseStyles } from "react-jss";
import { alpha } from "../../theme/Mixins";

export default createUseStyles({
    container: {
        position: "relative",
        width: ({ isMobileView }) => (isMobileView ? "100%" : "auto"),
    },
    statementsContainer: {
        width: ({ isMobileView }) => (isMobileView ? "100%" : "auto"),
        display: "flex",
        overflowX: "hidden",
        scrollBehavior: "smooth",
        margin: "0 auto",
        justifyContent: "center",
    },
    statement: {
        width: ({ isMobileView }) => (!isMobileView ? "460px" : "100%"),
        height: ({ isMobileView, contentResponsivenessOption }) => {
            let calHeight = "460px";
            if (isMobileView && contentResponsivenessOption !== "resize-carousel") {
                calHeight = "293px";
            } else if (contentResponsivenessOption === "resize-carousel") {
                calHeight = "auto";
            }
            return calHeight;
        },
        backgroundColor: ({ color }) => color,
        color: "#555555",
        textAlign: "center",
        minWidth: ({ isMobileView }) => (isMobileView ? "100%" : ""),
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: ({ justifyContent }) => justifyContent,
        background: ({ theme, color }) =>
            `${
                theme.ShowStatementBackgroundSettings
                    ? alpha(color ?? theme.ControlBackground, theme.StatementBackgroundAlpha)
                    : alpha(theme.ControlBackground, 0)
            }`,
        borderRadius: ({ theme, isMobileView }) =>
            `${
                theme.ShowStatementBackgroundSettings
                    ? Math.min(
                          theme.CustomBorderValue
                              ? theme.StatementBorderRadius
                              : theme.ChoiceListBackgroundBorderRadius,
                          (isMobileView ? 293 : 460) / 2,
                      )
                    : ""
            }px`,

        "& .statementTextContent": {
            padding: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: "1.2",
        },

        "& .statementTextContent:empty": {
            display: "none",
        },

        "& .image-wrapper": {
            display: "flex",
            justifyContent: "center",
            width: ({ isMobileView }) => (isMobileView ? "100%" : "auto"),
            height: ({ contentResponsivenessOption }) =>
                contentResponsivenessOption === "resize-carousel" ? "auto" : "100%",
            flex: 1,

            "& .image-element": {
                borderRadius: ({ theme }) => {
                    if (!theme.ShowStatementBackgroundSettings || !theme.CustomBorderValue) {
                        if (theme.ChoiceListBackgroundBorderRadius === 100) return "20px";
                        if (theme.ChoiceListBackgroundBorderRadius === 15) return "8px";
                    }

                    if (
                        theme.ShowStatementBackgroundSettings &&
                        theme.StatementBackgroundAlpha === 0
                    ) {
                        return `${theme.StatementBorderRadius}px`;
                    }
                    return "";
                },
            },
        },

        "& .crop-image": {
            width: ({ isMobileView }) => (isMobileView ? "100%" : "460px"),
            height: ({ isMobileView }) => (isMobileView ? "235px" : "368px"),
            objectFit: "cover",
            objectPosition: "center center",
        },
        "& .fade-in-element": { animation: "mbsc-anim-f-in 2s" },
    },
    navigationButtonsPanel: {
        textAlign: "center",
        display: "flex",
        justifyContent: ({ justifyContent }) => justifyContent,
        marginTop: "25px",

        "& .fixedWidth": {
            flex: "0 0 20px",
            minWidth: "20px",
            display: "flex",
            alignItems: "center",
        },
    },
    navigationButton: {
        height: "100%",
        cursor: "pointer",
    },
});
